import ApiUsers from '@/api/apiUsers'
import Vue from 'vue'
import router from '../router'
import User from '@/models/user'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
});

const state = {
  users: [],
  user: new User()
}

const actions = {
  loadUsers(context, data) {
    startLoading(context.dispatch, 'loading users')
    ApiUsers.all((users) => {
      context.commit("updateUsers", users)
      endLoading(context.dispatch, 'loading users')
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'loading users')
    })
  },
  loadUser(context, userID) {
    if (userID){
      startLoading(context.dispatch, 'loading user')
      context.commit("updateUser", new User())
      ApiUsers.find(userID,
      (user) => {
        context.commit("updateUser", user)
        endLoading(context.dispatch, 'loading user')
      }, error => {
        endLoading(context.dispatch, 'loading user')
        console.log(error)
      })
    }
  },
  createUser(context, user) {
    startLoading(context.dispatch, 'creating user')
    ApiUsers.create(user, (response) => {
      endLoading(context.dispatch, 'creating user')
      context.commit('updateUser', new User())
      context.dispatch('goUsers')
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'creating user')
    })
  },
  updateUser(context, user) {
    startLoading(context.dispatch, 'updating user')
    ApiUsers.update(user, (response) => {
      endLoading(context.dispatch, 'updating user')
      context.commit('updateUser', new User())
      context.dispatch('goUsers')
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'updating user')
    })
  },
  removeUser(context, user){
    startLoading(context.dispatch, 'removing user')
    ApiUsers.delete(user, (response) => {
      context.dispatch('loadUsers')
      endLoading(context.dispatch, 'removing user')
      console.log(context)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'removing user')
    })
  },
  activeUser(context, user){
    startLoading(context.dispatch, 'updating user')
    ApiUsers.active(user, (response) => {
      context.dispatch('loadUsers')
      endLoading(context.dispatch, 'updating user')
      console.log(context)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'updating user')
    })
  }
}

const mutations = {
  updateUsers(state,users) {
    state.user = new User()
    state.users = users
  },
  updateUser(state, user) {
    state.user = user
  }
}

const getters = {
  currentUsers(state) {
    return state.users
  },
  currentUser(state) {
    return state.user
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/users.js